import { useEffect, useState } from 'react';

const SCREEN_SIZE = {
    SMALL: 768,
    MEDIUM: 992,
    LARGE: 1200,
};

export default ({
    hasEXTJS,
    hasFlexibleLayoutSidePanel,
    onSmallScreen,
    onMediumScreen,
    onLargeScreen,
}) => {
    const [currentBreakpoint, setCurrentBreakpoint] = useState(null);

    useEffect(() => {
        function handleResize() {
            const width = window.innerWidth;

            if (width <= 600 || hasFlexibleLayoutSidePanel) {
                if (currentBreakpoint === 'small') return;
                onSmallScreen();
                setCurrentBreakpoint('small');
             
            } else if ((width > 600 && width <= SCREEN_SIZE.SMALL && !hasFlexibleLayoutSidePanel) || hasEXTJS) {
                if (currentBreakpoint === 'medium') return;
                setCurrentBreakpoint('medium');
                onMediumScreen();
            } else {
                if (currentBreakpoint === 'large') return;
                setCurrentBreakpoint('large');
                onLargeScreen();
            }
        }

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, [
        hasEXTJS,
        currentBreakpoint,
        onSmallScreen,
        onMediumScreen,
        onLargeScreen,
    ]);
};
